import React from "react";
import LinearProgress from '@mui/material/LinearProgress';

class Downloading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
        <LinearProgress sx={{position: "absolute", width: "100%", left: 0, top: "40px", height:"6px",  zIndex: "1005"}} />
    );
  }
}

export default Downloading;
